<template>
    <div class="aipage">
      <extraPage :content="content"></extraPage>
    </div>
</template>
<script>
import extraPage from '@/components/extraPage.vue'
/* eslint-disable */
export default {
    components: {
        extraPage,
    },
    data() {
        return {
          content:{
                bannerTitle: require("@/assets/images/bussiness/stor/storTitle.png"),
                bannerSmallTitle: '一体化数据存储流转平台，提供安全可靠的持久化数据服务',
                productOverviewTitle: '',
                productOverviewImg: require("@/assets/images/bussiness/stor/stor_wrapbg1.png"),
                productArchitectureImg2: require("@/assets/images/bussiness/stor/stor_wrapbg2.png"),
                productCapacityImg: require("@/assets/images/bussiness/stor/stor_wrapbg3.png"),
                productOverviewContent: '分布式存储平台是一款面向海量非结构化数据的统一数据存储平台，同时支持多种数据访问协议及多协议间数据无损互通，满足数据全生命周期管理的需求，为上层业务提供高可靠、易扩展、高性价比的海量数据存储。作为数据存储和流转中心，用户通过文件、对象、大数据接口等多种协议高效存取和管理日志、图片、音视频、文档、邮件、数据表、训练数据集等各类型文件，支撑企业丰富的上层业务和数据分析系统应用，帮助企业持续最大化地利用数据价值，更快地获取商业洞察。',
                aiContentList: [
                    { title: 'AI赋能', wrapPic: require("@/assets/images/bussiness/stor/wrapbg1.png"), content:'构建高可靠数据存储与智能流转体系，加速AI模型全生命周期（训练/推理/调优）' },
                    { title: '超算存储', wrapPic: require("@/assets/images/bussiness/stor/wrapbg2.png"), content:'提供并行文件系统支持，满足HPC场景百万级IOPS与EB级吞吐需求' },
                    { title: '企业办公协同', wrapPic: require("@/assets/images/bussiness/stor/wrapbg3.png"), content:'PB级安全存储空间与毫秒级检索能力，重塑企业数字资产协作模式' },
                    { title: '智慧医疗', wrapPic: require("@/assets/images/bussiness/stor/wrapbg4.png"), content:'符合HIPAA标准的医疗影像存储方案，支持DICOM等专业格式分布式处理' },
                ],
                productGoodsList: [
                    { title: '统一智能存储底座', wrapPic: require("@/assets/images/bussiness/stor/wrapbg6.png"), content:'构建跨数据类型的统一存储平台，通过智能冷热分层技术实现PB级数据的高效管理。' },
                    { title: '超高性能数据处理', wrapPic: require("@/assets/images/bussiness/stor/wrapbg7.png"), content:'支持并行文件访问，实现百GB级稳定带宽输出，支持千节点级并发访问。' },
                    { title: '零门槛运维体验', wrapPic: require("@/assets/images/bussiness/stor/wrapbg8.png"), content:'提供类互联网产品的交互界面，集成拖拽上传、智能分类、版本回溯等实用功能。' },
                    { title: '弹性资源供给', wrapPic: require("@/assets/images/bussiness/stor/wrapbg9.png"), content:'通过智能预测算法自动规划资源配额，配合用量监控看板，帮助企业实现存储资源利用率提升40%以上，杜绝资源闲置浪费。' },
                ],
                productCapacityList:[
                    { title:'全域数据互联互通', content:'采用多协议融合架构，原生支持文件（POSIX/SMB/NFS/FTP）、对象（S3/OSS）及大数据（HDFS）协议的无损互通。通过统一数据视图实现跨协议直接访问，消除数据孤岛，节省30%以上的存储冗余成本，显著提升跨业务系统的数据协同效率。' },
                    { title:'全栈自主可控', content:'基于完全自主研发的存储内核，通过鲲鹏等国产化生态认证。深度适配国产芯片和操作系统，提供从硬件到软件的全链路信创支持，确保核心技术自主可控，满足关键行业的安全合规要求。' },
                    { title:'弹性无限扩展', content:'采用分布式架构设计，支持从2节点到4096节点的线性扩展，单集群可扩展至EB级容量。独创的百亿级文件索引技术，保障海量小文件场景下的高性能访问，支撑业务持续增长无需架构改造。' },
                    { title:'智能数据治理', content:'集成数据全生命周期管理能力，提供智能分层、跨云迁移、实时备份等企业级功能。内置多媒体处理引擎（图片/视频/流媒体转码），结合统一元数据服务，实现存算一体的智能化数据管理。' },
                ],
                caseList: [
                    { title: '银行统一存储&数据灾备', content:'', wrapPic: require("@/assets/images/bussiness/stor/stor_wrapbg4.png"),  },
                    { title: '医院影像存储', content:'', wrapPic: require("@/assets/images/bussiness/stor/stor_wrapbg5.png"),  },
                    { title: '企业文件管理平台', content:'', wrapPic: require("@/assets/images/bussiness/stor/stor_wrapbg6.png"),  },
                    { title: '电商图片存储', content:'', wrapPic: require("@/assets/images/bussiness/stor/stor_wrapbg7.png"),  },
                ]
            }
        }
    },
    methods: {
        
    }
}
</script>